import PropTypes from "prop-types";

import Dropdown from "react-bootstrap/Dropdown";

import { RenderWhen } from "../../components";
import FileAnalysisModal from "../../components/FileAnalysisModal";
import Icon from "../../components/Icon";
import SubmitUrlModal from "../../components/SubmitUrlModal";
import VerticalDivider from "../../components/VerticalDivider";

import useToggle from "../../hooks/useToggle";

const GlobalUploadButton = ({ onUpload }) => {
  const [
    isFileAnalysisModalOpen,
    setFileAnalysisModalOpen,
    toggleFileAnalysisModal
  ] = useToggle();
  const [isUrlModalOpen, setUrlModalOpen, toggleUrlModal] = useToggle();

  return (
    <div className="rlbs flex" style={{ alignItems: "center" }}>
      <Dropdown id="global-upload-dropdown" className="global-upload-dropdown">
        <Dropdown.Toggle
          id="global-upload-dropdown__btn"
          size="sm"
          variant="link"
          className="global-upload-dropdown__btn"
          data-testid="global-upload-button"
        >
          <strong
            id="global-upload-dropdown__btn__title"
            className="global-upload-dropdown__title"
          >
            Submit
          </strong>
          <Icon
            id="global-upload-dropdown__btn__icon"
            name="global_upload"
            className="global-upload-dropdown__icon"
          />
        </Dropdown.Toggle>
        <Dropdown.Menu
          renderOnMount
          id="global-upload-dropdown-menu"
          className="dropdown-menu--light global-upload-dropdown__menu"
        >
          <Dropdown.Item
            onClick={toggleFileAnalysisModal}
            data-testid="global-upload-menu-item-file-analysis"
          >
            File Analysis
          </Dropdown.Item>
          <Dropdown.Item
            onClick={toggleUrlModal}
            data-testid="global-upload-menu-item-submit-url"
          >
            URL Analysis
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <VerticalDivider color="black" />
      <FileAnalysisModal
        key={isFileAnalysisModalOpen}
        showModal={isFileAnalysisModalOpen}
        closeModal={() => setFileAnalysisModalOpen(false)}
        handleUpload={onUpload}
      />
      <RenderWhen condition={isUrlModalOpen}>
        <SubmitUrlModal
          show={isUrlModalOpen}
          handleShow={() => setUrlModalOpen(false)}
        />
      </RenderWhen>
    </div>
  );
};

GlobalUploadButton.propTypes = {
  onUpload: PropTypes.func.isRequired
};

export default GlobalUploadButton;
